// Infinite Scroll for Collection Pages - Aggressive Filter Handling
(function() {
  'use strict';
  
  // Configuration
  const config = {
    container: '#product-grid',
    productItem: '.grid__item',
    pagination: '.pagination',
    nextButton: '.pagination__item--next a, .pagination a[aria-label="Next page"]',
    loadingOffset: 1700,
    loadingText: 'Loading more products...'
  };
  
  let isLoading = false;
  let hasMorePages = true;
  let currentPage = 1;
  let triggerElement = null;
  let observer = null;
  let loadingIndicator = null;
  
  // Force hide pagination continuously
  function forcehidePagination() {
    const pagination = document.querySelector(config.pagination);
    if (pagination && pagination.style.display !== 'none') {
      pagination.style.display = 'none';
    }
  }
  
  // Continuously check and hide pagination every 100ms
  setInterval(forcehidePagination, 100);
  
  // Main initialization function
  function initInfiniteScroll() {
    const container = document.querySelector(config.container);
    if (!container) {
      setTimeout(initInfiniteScroll, 200);
      return;
    }
    
    // Remove old loading indicator if exists
    const oldIndicator = document.querySelector('.infinite-scroll-loading');
    if (oldIndicator) {
      oldIndicator.remove();
    }
    
    // Reset state
    isLoading = false;
    hasMorePages = true;
    currentPage = 1;
    
    // Create loading indicator
    loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'infinite-scroll-loading';
    loadingIndicator.style.cssText = 'text-align: center; padding: 40px 20px; display: none;';
    loadingIndicator.innerHTML = `
      <div class="loading-spinner">
        <svg class="spinner" width="40" height="40" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
        </svg>
        <p style="margin-top: 15px; color: #666; font-size: 14px;">${config.loadingText}</p>
      </div>
    `;
    
    // Insert loading indicator
    container.insertAdjacentElement('afterend', loadingIndicator);
    
    // Force hide pagination
    forcehidePagination();
    
    // Initialize trigger
    initializeTrigger();
  }
  
  // Get next page URL
  function getNextPageUrl() {
    const nextButton = document.querySelector(config.nextButton);
    if (!nextButton) {
      hasMorePages = false;
      return null;
    }
    return nextButton.href;
  }
  
  // Reinitialize trigger element
  function initializeTrigger() {
    const container = document.querySelector(config.container);
    if (!container) return;
    
    // Remove old trigger
    if (triggerElement && triggerElement.parentNode) {
      if (observer) {
        observer.unobserve(triggerElement);
      }
      triggerElement.remove();
    }
    
    // Create new trigger
    triggerElement = document.createElement('div');
    triggerElement.className = 'infinite-scroll-trigger';
    triggerElement.style.cssText = 'height: 1px; width: 100%; pointer-events: none;';
    
    // Insert trigger
    const allProducts = container.querySelectorAll(config.productItem);
    if (allProducts.length > 6) {
      const triggerPosition = allProducts[allProducts.length - 6];
      triggerPosition.insertAdjacentElement('afterend', triggerElement);
    } else if (allProducts.length > 0) {
      container.appendChild(triggerElement);
    }
    
    // Observe
    if (observer && triggerElement) {
      observer.observe(triggerElement);
    }
  }
  
  // Load next page
  async function loadNextPage() {
    if (isLoading || !hasMorePages) return;
    
    const nextUrl = getNextPageUrl();
    if (!nextUrl) {
      hasMorePages = false;
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      return;
    }
    
    isLoading = true;
    if (loadingIndicator) loadingIndicator.style.display = 'block';
    
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const container = document.querySelector(config.container);
      if (!container) return;
      
      const newProductGrid = doc.querySelector(config.container);
      if (!newProductGrid) {
        hasMorePages = false;
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        return;
      }
      
      const newProducts = newProductGrid.querySelectorAll(config.productItem);
      
      if (newProducts.length === 0) {
        hasMorePages = false;
        if (loadingIndicator) {
          loadingIndicator.innerHTML = '<p style="text-align: center; color: #999; padding: 20px;">You\'ve viewed all products</p>';
          loadingIndicator.style.display = 'block';
        }
        return;
      }
      
      // Append new products
      const fragment = document.createDocumentFragment();
      newProducts.forEach(product => {
        fragment.appendChild(product.cloneNode(true));
      });
      container.appendChild(fragment);
      
      // Update pagination
      const paginationWrapper = document.querySelector(config.pagination);
      const newPagination = doc.querySelector(config.pagination);
      if (newPagination && paginationWrapper) {
        paginationWrapper.innerHTML = newPagination.innerHTML;
        paginationWrapper.style.display = 'none';
      } else {
        hasMorePages = false;
        if (loadingIndicator) {
          loadingIndicator.innerHTML = '<p style="text-align: center; color: #999; padding: 20px;">You\'ve viewed all products</p>';
          loadingIndicator.style.display = 'block';
        }
      }
      
      currentPage++;
      
      if (window.history && window.history.pushState) {
        window.history.pushState({page: currentPage}, '', nextUrl);
      }
      
      initializeTrigger();
      
      document.dispatchEvent(new CustomEvent('infinite-scroll:loaded', {
        detail: { page: currentPage }
      }));
      
    } catch (error) {
      console.error('Infinite scroll error:', error);
      hasMorePages = false;
      if (loadingIndicator) loadingIndicator.style.display = 'none';
    } finally {
      isLoading = false;
      if (hasMorePages && loadingIndicator) {
        loadingIndicator.style.display = 'none';
      }
    }
  }
  
  // Check scroll
  function checkScroll() {
    if (isLoading || !hasMorePages) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    const isMobile = window.innerWidth < 750;
    const offset = isMobile ? Math.max(windowHeight * 2, 1500) : config.loadingOffset;
    
    if (scrollTop + windowHeight >= documentHeight - offset) {
      loadNextPage();
    }
  }
  
  // Intersection Observer
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !isLoading && hasMorePages) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '0px 0px 1500px 0px'
    });
  }
  
  // Scroll listener
  let scrollTimeout;
  const isMobile = window.innerWidth < 750;
  const throttleDelay = isMobile ? 50 : 100;
  
  window.addEventListener('scroll', function() {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkScroll, throttleDelay);
  }, { passive: true });
  
  // Watch for DOM changes and reinitialize
  const mainObserver = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Check if product grid was updated
          if (node.id === 'product-grid' || 
              (node.querySelector && node.querySelector('#product-grid'))) {
            shouldReinit = true;
          }
          // Check if pagination appeared
          if (node.classList && node.classList.contains('pagination')) {
            forcehidePagination();
            shouldReinit = true;
          }
        }
      });
    });
    
    if (shouldReinit) {
      console.log('DOM changed - reinitializing infinite scroll');
      setTimeout(initInfiniteScroll, 100);
    }
  });
  
  // Observe the entire main content
  const observeTarget = document.querySelector('main#MainContent') || document.querySelector('main') || document.body;
  mainObserver.observe(observeTarget, {
    childList: true,
    subtree: true
  });
  
  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initInfiniteScroll();
      setTimeout(checkScroll, 500);
    });
  } else {
    initInfiniteScroll();
    setTimeout(checkScroll, 500);
  }
  
})();
